export default {
    transactions_requests_title: 'Solicitudes de Transacciones',
    transactions_requests_transaction: 'Id',
    transactions_requests_message: 'Mensaje de Error',
    transactions_requests_data: 'Datos',
    transactions_requests_duplicated_device: "Dispositivo Duplicado",
    transactions_requests_success: "Éxito",
    transactions_requests_failure: "Error",
    transactions_requests_pending: "Pendiente",
    transactions_requests_show_data: 'Mostrar Datos',

    transactions_requests_company_name: "Cuenta",
    transactions_requests_type: 'Tipo',
    transactions_requests_project_id: "Plataforma",
    transactions_requests_processing_status: "Estado",
    transactions_requests_created: 'Creado',
    transactions_requests_created_by: 'Creado Por',
    transactions_requests_updated: "Actualizado",
    transactions_requests_id: "Id Transacción",
    transactions_requests_script_calamp_devices: "Scripts Dispositivos Calamp",
    transactions_requests_create_queclink_devices: "Creación Dispositivos Queclink",
    transactions_requests_import_units: "Importación de Dispositivos",
    transactions_requests_vidFleet_reboot_devices: "Reinicio Dispositivos VidFleet",
    transactions_requests_reprocess_odo_hrs: "Reproceso Odometros/Horas",
    transactions_requests_diagnostic_units: "Diagnostico Dispositivos",
    transactions_requests_date_range: "Rango de Fechas",
    transactions_requests_resync: "Sincronizar Datos con Zonar",
};